﻿import { SystemError } from 'common/exceptions/systemerror';

export class SystemErrorMessage {
    constructor(public t: SystemError, public continueAction: () => void = () => { }) { }

    static eventName() { return 'SystemErrorMessage'; }

    eventName = SystemErrorMessage.eventName;
}